import React, { Fragment } from "react";
import WebScan from "../../../../../componets/_webScan";
import GetVendors from "../api/GetVendors";
import GetDevices from "../api/GetDevices";
import GetRepairTypes from "../api/GetRepairType";
import GetResellers from "../api/GetResellers";
import GetPriorZprac from "../api/GetPriorZprac";
import GetPrislus from "../api/GetPrislus";
import PostApiData from "../api/PostApiData";
import PostHistoryData from "../api/PostHistoryData";
import GetDefectCodes from "../api/GetDefectCodes";
import GetDeviceState from "../api/GetDeviceState";
import GetSamCustType from "../api/GetSamCustType";
import GetNokCustType from "../api/GetNokCustType";
import SetManageDoc from "../api/SetManageDoc";
import GetSamCustSw from "../api/GetSamCustSw";
import GetCustReq from "../api/GetCustReq";
import GetOta from "../api/GetOta";
import GetTccmLocation from "../api/GetTccmLocation";
import Disagreement from "../constants/disagreement.json";
import AlcatelProdDateParser from "./ALC_ProductionDateParser.json";
import LookUpData from "./lookUpData";

class NewDocument extends React.Component {
  date = new Date();
  timer = null;
  state = {
    selectedActualApiData: -1,
    selectGroup: 0,
    value: "",
    scanShow: false,
    disagreement: Disagreement,
    docno: {
      DocNo: -1,
      DeviceFirmCode: null,
      FirmName: null,
      DeviceType: null,
      DeviceRepairType: null,
      DeviceRepairPrice: null,
      InRepType: null,
      DeviceReseller: null,
      DeviceSN: null,
      NumAtCard: null,
      StavPristroje: null,
      CisPoj: null,
      PrioritaZprac: null,
      Prislus: null,
      PrislusOth: null,
      ProductCodeSN: null,
      DeviceDefectDescEx: null,
      DatProdej: null,
      DatExtPr: null,
      BattYN: 0,
      BattSN: null,
      SAM_SWCust: null,
      SAM_CustType: null,
      SAM_DatVyr: null,
      OTA: null,
      SAM_SAW: null,
      SAM_DuvodOTA: null,
      SAM_DatAct: null,
      SAM_RepairRepeated: null,
      DatUkRek: null,
      DatUkZar: null,
      NOK_CustType: null,
      NOK_SalesCode: null,
      ALC_ProductionDate: null,
      ALC_ProductionDate_NUM: null,
      ALC_PuvodniIMEI: null,
      ICS_HWV_In: null,
      APL_FMI: null,
      APL_CiziDistribuce: null,
      APL_Dokumenty: null,
      APL_Neshoda: null,
      ALC_DatUkZar: null,
      TCCM_Urceni: null,
      Predprodej: 0,
      ALL_Zamek: null,
      ALL_ChybiDoklad: null,
      documents: [],
      disagreement: [],
      DeviceDefect1: null,
      DeviceDefect1Ver: null,
      DeviceDefect2: null,
      DeviceDefect2Ver: null,
      DeviceDefect3: null,
      DeviceDefect3Ver: null,
    },
    brtxcard: {
      open: false,
      value: null,
    },
    vendor: {
      loading: false,
      data: [],
      selected: null,
    },
    device: {
      loading: false,
      data: [],
      selected: null,
    },
    reseller: {
      loading: false,
      data: [],
      selected: null,
    },
    imei: {
      loading: false,
      data: [],
      selected: null,
      searchBy: "",
    },
    productCodeSN: {
      loading: false,
      data: [],
      selected: null,
      searchBy: "",
    },
    insuranceNo: {
      loading: false,
      data: [],
      selected: null,
    },
    numAtCard: {
      loading: false,
      data: [],
      selected: null,
    },
    tccmUrceni: {
      loading: false,
      data: [],
    },
    ota: {
      loading: false,
      data: [],
    },
    samCustType: {
      loading: false,
      data: [],
    },
    nokCustType: {
      loading: false,
      data: [],
    },
    samCustSw: {
      loading: false,
      data: [],
    },
    defect: {
      loading: false,
      data: [],
      selected1: null,
      selected2: null,
      selected3: null,
    },
    reptype: [],
    priorZprac: [],
    custReq: [],
    deviceState: [],
    prislus: [],
    loading: false,
    dataLookup: [],
    alertError: {
      text: "",
      show: false,
    },
  };

  alcatel_production_translate = (e) => {
    try {
      let eDay = AlcatelProdDateParser.day.filter(
        (f) => f.value === e.substring(0, 1)
      )[0].retValue;
      let eMonth = AlcatelProdDateParser.month.filter(
        (f) => f.value === e.substring(1, 2)
      )[0].retValue;
      let eYear = AlcatelProdDateParser.year.filter(
        (f) => f.value === e.substring(2, 3)
      )[0].retValue;
      this.setState({
        docno: {
          ...this.state.docno,
          ALC_ProductionDate_NUM: eDay + "." + eMonth + "." + eYear,
          ALC_ProductionDate: e,
        },
      });
    } catch {
      this.props.setToast(
        "Pro tento datum výroby FR nemám překlad.",
        "ALCATEL ProductionDate Translate",
        "DANGER"
      );
    }
  };

  searchByNumAtCard = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({
        numAtCard: {
          ...this.state.numAtCard,
          loading: true,
          data: [],
          selected: null,
        },
      });
      var _res = await PostApiData({ ...this.props, numAtCard: e });
      if (_res.status === 200) {
        this.setState({
          numAtCard: {
            ...this.state.numAtCard,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      } else {
        this.setState({
          numAtCard: {
            ...this.state.numAtCard,
            loading: false,
            data: [],
            searchBy: "API DATA",
          },
        });
      }
    }, 2000);
  };

  searchByInsuranceNo = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({
        numAtCard: {
          ...this.state.numAtCard,
          loading: true,
          data: [],
          selected: null,
        },
      });
      var _res = await PostApiData({ ...this.props, insuranceNo: e });
      if (_res.status === 200) {
        this.setState({
          insuranceNo: {
            ...this.state.insuranceNo,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      } else {
        this.setState({
          insuranceNo: {
            ...this.state.insuranceNo,
            loading: false,
            data: [],
            searchBy: "API DATA",
          },
        });
      }
    }, 300);
  };

  searchByImei = async (e) => {
    clearTimeout(this.timer);
    if (e.length < 6) return;
    this.timer = setTimeout(async () => {
      this.setState({
        imei: { ...this.state.imei, loading: true, data: [], selected: null },
      });
      var _res = await PostApiData({ ...this.props, deviceSN: e });
      if (_res.status === 200) {
        this.setState({
          dataLookup: _res.data,
          searchBy: "API DATA",
          imei: {
            ...this.state.imei,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      } else {
        var _resH = await PostHistoryData({
          ...this.props,
          deviceSN: e,
          deviceFirmCode: this.state.docno.DeviceFirmCode,
        });
        if (_resH.status === 200) {
          this.setState({
            dataLookup: _resH.data,
            searchBy: "Servis21 Historie",
            imei: {
              ...this.state.imei,
              loading: false,
              data: _resH.data,
              searchBy: "S21 HISTORIE",
            },
          });
        } else {
          this.setState({
            imei: {
              ...this.state.imei,
              searchBy: "Servis21 Historie",
              loading: false,
              data: [],
            },
          });
        }
      }
    }, 300);
  };

  searchByproductCodeSN = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({
        productCodeSN: {
          ...this.state.productCodeSN,
          loading: true,
          data: [],
          selected: null,
        },
      });
      var _res = await PostApiData({ ...this.props, productCodeSN: e });
      if (_res.status === 200) {
        this.setState({
          productCodeSN: {
            ...this.state.productCodeSN,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      } else {
        var _resH = await PostHistoryData({
          ...this.props,
          productCodeSN: e,
          deviceFirmCode: this.state.docno.DeviceFirmCode,
        });
        if (_resH.status === 200) {
          this.setState({
            productCodeSN: {
              ...this.state.productCodeSN,
              loading: false,
              data: _resH.data,
              searchBy: "Servis21 HISTORIE",
            },
          });
        } else {
          this.setState({
            productCodeSN: {
              ...this.state.productCodeSN,
              loading: false,
              data: [],
              searchBy: "S21 HISTORIE",
            },
          });
        }
      }
    }, 300);
  };

  GetVendors = async (e) => {
    this.setState({ loading: true });
    var _res = await GetVendors({ ...this.props, query: e });
    this.setState({ loading: false });
    if (_res.status === 200) {
      var vend = JSON.parse(this.props._decrypt(_res.data));
      var parsedata = [];
      // eslint-disable-next-line array-callback-return
      vend.map((e) => {
        let n = { value: e.FirmCode, label: e.FirmName, logo: e.webImgLogo };
        parsedata.push(n);
      });
      this.setState({
        vendor: { ...this.state.vendor, loading: false, data: parsedata },
      });
    }
  };

  getTccmLoccation = async (e) => {
    this.setState({
      tccmUrceni: { ...this.state.tccmUrceni, loading: true },
    });
    var _res = await GetTccmLocation({ ...this.props, query: e });
    if (_res.status === 200) {
      this.setState({
        tccmUrceni: {
          ...this.state.tccmUrceni,
          loading: false,
          data: _res.data,
        },
      });
    }
  };

  ota = async (e) => {
    this.setState({
      ota: { ...this.state.ota, loading: true },
    });
    var _res = await GetOta({ ...this.props, query: e });
    if (_res.status === 200) {
      this.setState({
        ota: {
          ...this.state.ota,
          loading: false,
          data: _res.data,
        },
      });
    }
  };

  GetSamCustType = async (e) => {
    this.setState({
      samCustType: { ...this.state.samCustType, loading: true },
    });
    var _res = await GetSamCustType({ ...this.props, query: e });
    if (_res.status === 200) {
      this.setState({
        samCustType: {
          ...this.state.samCustType,
          loading: false,
          data: _res.data,
        },
      });
    }
  };

  GetNokCustType = async (e) => {
    this.setState({
      samCustType: { ...this.state.samCustType, loading: true },
    });
    var _res = await GetNokCustType({ ...this.props, query: e });
    if (_res.status === 200) {
      this.setState({
        nokCustType: {
          ...this.state.nokCustType,
          loading: false,
          data: _res.data,
        },
      });
    }
  };

  GetSamCustSw = async (e) => {
    this.setState({
      samCustSw: { ...this.state.samCustSw, loading: true },
    });
    var _res = await GetSamCustSw({ ...this.props, query: e });
    if (_res.status === 200) {
      this.setState({
        samCustSw: {
          ...this.state.samCustSw,
          loading: false,
          data: _res.data,
        },
      });
    }
  };

  searchVendors = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ vendor: { ...this.state.vendor, loading: true } });
      var _res = await GetVendors({ ...this.props, query: e });
      if (_res.status === 200) {
        var vend = JSON.parse(this.props._decrypt(_res.data));
        var parsedata = [];
        // eslint-disable-next-line array-callback-return
        vend.map((e) => {
          let n = { value: e.FirmCode, label: e.FirmName, logo: e.webImgLogo };
          parsedata.push(n);
        });
        this.setState({
          vendor: { ...this.state.vendor, loading: false, data: parsedata },
        });
      } else {
        this.setState({
          vendor: { ...this.state.vendor, loading: false, data: [] },
        });
      }
    }, 500);
  };

  searchDevice = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ device: { ...this.state.device, loading: true } });
      var _res = await GetDevices({
        ...this.props,
        firmCode: this.state.docno.DeviceFirmCode,
        query: e,
      });

      if (_res.status === 200) {
        var dev = JSON.parse(this.props._decrypt(_res.data));
        var parsedata = [];
        // eslint-disable-next-line array-callback-return
        dev.map((e) => {
          let n = { DeviceType: e.TypeId, label: e.TypeName };
          parsedata.push(n);
        });
        this.setState({
          device: { ...this.state.device, loading: false, data: parsedata },
        });
      } else {
        this.setState({
          device: { ...this.state.device, loading: false, data: [] },
        });
      }
    }, 1000);
  };

  searchReseller = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ reseller: { ...this.state.reseller, loading: true } });
      var _res = await GetResellers({
        ...this.props,
        query: e,
      });
      if (_res.status === 200) {
        this.setState({
          reseller: { ...this.state.reseller, loading: false, data: _res.data },
        });
      } else {
        this.setState({
          reseller: { ...this.state.reseller, loading: false, data: [] },
        });
      }
    }, 500);
  };

  searchImei = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ imei: { ...this.state.imei, loading: true } });
      var _res = await GetResellers({
        ...this.props,
        query: "hjdshgfkjdshfkjdhskjd",
      });
      if (_res.status === 200) {
        this.setState({
          imei: { ...this.state.imei, loading: false, data: _res.data },
        });
      } else {
        this.setState({
          imei: {
            ...this.state.imei,
            loading: false,
            data: [{ value: -1, label: e }],
          },
        });
      }
    }, 2000);
  };

  GetRepairTypesData = async () => {
    var _res = await GetRepairTypes({ ...this.props });
    if (_res.status === 200) {
      this.setState({ reptype: _res.data });
    }
  };

  GetPriorZpracData = async () => {
    var _res = await GetPriorZprac({ ...this.props });
    if (_res.status === 200) {
      this.setState({ priorZprac: _res.data });
    }
  };

  GetCustReqData = async () => {
    var _res = await GetCustReq({ ...this.props });
    if (_res.status === 200) {
      this.setState({ custReq: _res.data });
    }
  };

  GetDefectCodes = async (e) => {
    var _res = await GetDefectCodes({ ...this.props, firmCode: e });
    if (_res.status === 200) {
      this.setState({ defect: { ...this.state.defect, data: _res.data } });
    }
  };

  GetDeviceState = async (e) => {
    var _res = await GetDeviceState({ ...this.props });
    if (_res.status === 200) {
      this.setState({ deviceState: _res.data });
    }
  };

  GetPrislusData = async () => {
    var _res = await GetPrislus({ ...this.props });
    if (_res.status === 200) {
      this.setState({ prislus: _res.data });
    }
  };

  async componentDidMount() {
    this.setState({ loading: true  });
    this.GetVendors("ALL");
    this.setState({
      docno: {...this.props.docno},
      dataLookup: this.props.apidata
    });
    this.GetRepairTypesData();
    this.GetPriorZpracData();
    this.GetPrislusData();
    this.GetDeviceState();
    this.GetCustReqData();
    if (
      this.props.docno.DeviceFirmCode &&
      this.props.docno.DeviceFirmCode > 0 &&
      !this.props.prepare
    )
      this.GetDefectCodes(this.props.docno.DeviceFirmCode);
  }

  create = async (prep) => {
    this.setState({ loading: true, alertError: { show: false, text: null } });
    const { create, card, shipDoc } = this.props;
    let docData = {
      card: card,
      shipDoc: shipDoc,
      doc: { ...this.state.docno, documents: null },
      documents: this.state.docno.documents,
      addDocScan: this.props.addDocScan,
      disagreement: this.state.disagreement,
      rfid: sessionStorage.getItem("RFID"),
      prepare: prep,
      brtxcard: this.state.brtxcard.value,
    };
    var _res = await SetManageDoc({ ...this.props, doc: docData });
    this.setState({
      loading: false,
      alertError: { shshowow: false, text: null },
    });
    if (_res.status === 200) {
      this.props.apiset(this.state.selectedActualApiData);
      create(_res.data.doc);
    } else {
      this.setState({
        loading: false,
        alertError: { show: true, text: _res.data.detail },
      });
      if (_res.data.detail.indexOf("RFID") > -1) this.props.resetRFID();
    }
  };

  replaceData = (e,idx) => {
    this.setState({
      docno: { ...this.state.docno, ...e },
      selectedActualApiData: idx
    })
  };

  render() {
    const { Bs, VARIANT, SIZE, Icon, close, open, prepare } = this.props;
    return (
      <>
        {this.state.dataLookup.length > 0 && (
          <LookUpData
            {...this.props}
            data={this.state.dataLookup}
            searchBy={this.state.searchBy}
            selectedData={this.replaceData}
          />
        )}

        <Bs
          modal
          show={this.state.brtxcard.open}
          keyboard={false}
          backdrop="static"
          centered
          size={SIZE.SMALL}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader>Zadej číslo BRTX karty</Bs>
          <Bs modalbody>
            <Bs row>
              <Bs col xs={12}>
                <Bs
                  formcontrol
                  value={this.state.brtxcard.value}
                  autoFocus
                  onChange={(e) =>
                    this.setState({
                      brtxcard: {
                        ...this.state.brtxcard,
                        value: e.target.value,
                      },
                    })
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.create("1");
                      this.setState({
                        brtxcard: { ...this.state.brtxcard, open: false },
                      });
                    }
                  }}
                ></Bs>
              </Bs>
            </Bs>
          </Bs>
          <Bs modalfooter>
            <Bs row>
              <Bs col xs={12}>
                <Bs
                  button
                  size={SIZE.SM}
                  variant={VARIANT.SUCCESS}
                  onClick={() => {
                    this.create("1");
                    this.setState({
                      brtxcard: { ...this.state.brtxcard, open: false },
                    });
                  }}
                >
                  Potvrdit
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>

        <Bs
          modal
          show={open}
          onHide={close}
          keyboard={false}
          backdrop="static"
          centered
          size={SIZE.LG}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader closeButton>
            {this.state.docno.DocNo > 0 && (
              <Bs span>
                Zakázka č.:
                <Bs strong className="ms-2">
                  {this.state.docno.DocNo}
                </Bs>
              </Bs>
            )}
            {this.state.docno.DocNo < 1 && <Bs span>Vytvořit novou zakázku</Bs>}
          </Bs>
          <Bs alert variant={VARIANT.UNI}>
            <Bs row>
              <Bs
                col
                xs={12}
                className="cursor-pointer d-flex justify-content-between"
                onClick={() =>
                  this.setState({ scanShow: !this.state.scanShow })
                }
              >
                <Bs span>Pořízené scany do zakázky</Bs>
                <Bs span>Počet souborů: {this.state.docno?.documents?.length}</Bs>
                <Bs span>
                  {!this.state.scanShow ? (
                    <Icon fimaximize className="c-secondary" />
                  ) : (
                    <Icon fiminimize className="c-secondary" />
                  )}
                </Bs>
              </Bs>
              {this.state.scanShow && (
                <Bs col xs={12}>
                  {/* Global scan function */}
                  <WebScan
                    {...this.props}
                    webCam
                    twain
                    mobile
                    docType
                    files={this.state.docno.documents}
                    setFiles={(e) =>
                      this.setState({
                        docno: { ...this.state.docno, documents: e },
                      })
                    }
                    docTypeFilter={["4", "8"]}
                  />
                </Bs>
              )}
            </Bs>
          </Bs>
          {this.state.alertError.show && (
            <Bs alert variant={VARIANT.DANGER}>
              <Bs row>
                <Bs col xs={12}>
                  {this.state.alertError.text}
                </Bs>
              </Bs>
            </Bs>
          )}
          <Bs row className="ms-4 me-4">
            <Bs col xs={12}>
              {this.state.loading && (
                <Bs div>
                  <Bs brtxspin className="c-secondary" />
                  <Bs small className="ms-2 text-muted">
                    Načítám data...
                  </Bs>
                </Bs>
              )}
              {prepare && (
                <Bs row>
                  <Bs col xs={12} lg={6}>
                    <Bs formtext>Výrobce</Bs>
                    <Bs
                      brtxselect
                      isDisabled={this.state.loading}
                      placeholder="Vyber výrobce"
                      isClearable
                      options={this.state.vendor.data.filter(
                        (f) => f.value > 0
                      )}
                      value={
                        this.state.vendor?.data.filter(
                          (f) =>
                            f.value?.toString() ===
                            this.state.docno?.DeviceFirmCode?.toString()
                        )[0]
                      }
                      onChange={(e) => {
                        this.setState({
                          vendor: {
                            ...this.state.vendor,
                            selected: null,
                          },
                          docno: {
                            ...this.state.docno,
                            DeviceFirmCode: e.value,
                            FirmName: e.label,
                            DeviceType: null,
                          },
                          device: {
                            data: [],
                            loading: false,
                            selected: null,
                          },
                        });
                      }}
                    />
                  </Bs>
                  <Bs col xs={12} lg={6}>
                    <Bs formtext>IMEI Zařízení</Bs>

                    <Bs
                      formcontrol
                      value={this.state.docno.DeviceSN}
                      onChange={(e) => {
                        this.searchByImei(e.target.value);
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            DeviceSN:
                              e.target.value.length === 0
                                ? null
                                : e.target.value,
                          },
                        });
                      }}
                    />
                  </Bs>
                  <Bs col xs={12} lg={4}>
                    <Bs formtext>Druh opravy</Bs>
                    <Bs
                      brtxselect
                      value={
                        this.state.reptype.filter(
                          (f) => f.value === this.state.docno.DeviceRepairType
                        )[0]
                      }
                      onChange={(e) =>
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            DeviceRepairType: e.value,
                          },
                        })
                      }
                      options={this.state.reptype}
                      placeholder="-- Vyber --"
                    />
                  </Bs>
                  <Bs col xs={12} lg={4}>
                    <Bs formtext id="basic-addon1">
                      Sériové číslo
                    </Bs>
                    <Bs
                      formcontrol
                      value={this.state.docno.ProductCodeSN}
                      onChange={(e) => {
                        this.searchByproductCodeSN(e.target.value);
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            ProductCodeSN:
                              e.target.value.length === 0
                                ? null
                                : e.target.value,
                          },
                        });
                      }}
                    />
                  </Bs>
                  <Bs col xs={12} lg={4}>
                    <Bs formtext id="basic-addon1">
                      Zakázka zákazníka
                    </Bs>
                    <Bs
                      formcontrol
                      value={this.state.docno.NumAtCard}
                      onChange={(e) => {
                        this.searchByNumAtCard(e.target.value);
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            NumAtCard:
                              e.target.value.length === 0
                                ? null
                                : e.target.value,
                          },
                        });
                      }}
                    />
                  </Bs>
                  <Bs col xs={12} lg={6}>
                    <Bs formtext id="basic-addon1">
                      Číslo pojištění
                    </Bs>
                    <Bs
                      formcontrol
                      value={this.state.docno.CisPoj}
                      onChange={(e) => {
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            CisPoj:
                              e.target.value.length === 0
                                ? null
                                : e.target.value,
                          },
                        });
                      }}
                    />
                  </Bs>
                  <Bs col xs={12} lg={6}>
                    <Bs formtext>Priorita zpracování</Bs>
                    <Bs
                      brtxselect
                      value={
                        this.state.priorZprac.filter(
                          (f) => f.value === this.state.docno.PrioritaZprac
                        )[0]
                      }
                      onChange={(e) =>
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            PrioritaZprac: e.value,
                          },
                        })
                      }
                      options={this.state.priorZprac}
                      placeholder="-- Vyber --"
                    />
                  </Bs>
                  <Bs col xs={12} lg={4}>
                    <Bs formtext>Datum prodeje</Bs>
                    <Bs
                      formcontrol
                      type="date"
                      disabled={
                        this.state.docno.Predprodej === 0 ? false : true
                      }
                      value={this.state.docno.DatProdej?.split("T")[0]}
                      onChange={(e) => {
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            DatProdej: e.target.value,
                          },
                        });
                      }}
                    />
                  </Bs>
                  <Bs col xs={12} lg={4}>
                    <Bs formtext>Předprodejní reklamace</Bs>
                    <Bs
                      formswitch
                      checked={this.state.docno.Predprodej === 0 ? false : true}
                      onChange={(e) =>
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            Predprodej: e.target.checked ? 1 : 0,
                            DatProdej: null,
                          },
                        })
                      }
                    />
                  </Bs>
                  <Bs col xs={12} lg={4}>
                    <Bs formtext>Datum externího příjmu</Bs>
                    <Bs
                      formcontrol
                      type="date"
                      value={this.state.docno.DatExtPr?.split("T")[0]}
                      onChange={(e) =>
                        this.setState({
                          docno: {
                            ...this.state.docno,
                            DatExtPr: e.target.value,
                          },
                        })
                      }
                    />
                  </Bs>
                </Bs>
              )}
              {!this.state.loading && !prepare && (
                <>
                  <Bs formtext>Výrobce</Bs>
                  <Bs
                    brtxselect
                    placeholder="Vyber výrobce"
                    isClearable
                    options={this.state.vendor.data.filter((f) => f.value > 0)}
                    value={
                      this.state.vendor?.data.filter(
                        (f) => f.value === this.state.docno?.DeviceFirmCode
                      )[0]
                    }
                    onChange={(e) => {
                      if (e.value === 2) {
                        this.ota();
                        this.GetSamCustType();
                        this.GetSamCustSw();
                      }
                      if (e.value === 1) this.GetNokCustType();
                      this.GetDefectCodes(e.value);
                      if (e.value === 49) this.getTccmLoccation();

                      this.setState({
                        vendor: {
                          ...this.state.vendor,
                          selected: null,
                        },
                        docno: {
                          ...this.state.docno,
                          DeviceFirmCode: e.value,
                          FirmName: e.label,
                          DeviceType: null,
                        },
                        device: {
                          data: [],
                          loading: false,
                          selected: null,
                        },
                      });
                    }}
                  />
                </>
              )}
            </Bs>
          </Bs>
          <Bs modalbody>
            {!this.state.loading && (
              <>
                {this.state.docno.DeviceFirmCode && !prepare && (
                  <>
                    <Bs row className="mb-2">
                      <Bs
                        nav
                        variant={VARIANT.TABS}
                        className="c-tab"
                        defaultActiveKey={this.state.selectGroup}
                      >
                        <Bs navitem>
                          <Bs
                            navlink
                            onClick={() => this.setState({ selectGroup: 0 })}
                            eventKey={0}
                          >
                            Důležité
                          </Bs>
                        </Bs>
                        <Bs navitem>
                          <Bs
                            navlink
                            onClick={() => this.setState({ selectGroup: 1 })}
                            eventKey={1}
                          >
                            Základní
                          </Bs>
                        </Bs>
                        <Bs navitem>
                          <Bs
                            navlink
                            onClick={() => this.setState({ selectGroup: 2 })}
                            eventKey={2}
                          >
                            Podle značky
                          </Bs>
                        </Bs>
                        <Bs navitem>
                          <Bs
                            navlink
                            onClick={() => this.setState({ selectGroup: 3 })}
                            eventKey={3}
                          >
                            Neshoda
                          </Bs>
                        </Bs>
                      </Bs>
                    </Bs>
                    {this.state.selectGroup === 0 && (
                      <Bs row>
                        <>
                          <Bs col xs={6} className="mt-4">
                            <Bs formtext>IMEI Zařízení</Bs>
                            {this.state.docno.DeviceSN && (
                              <Bs
                                formcontrol
                                value={this.state.docno.DeviceSN}
                                onChange={(e) => {
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      DeviceSN:
                                        e.target.value.length === 0
                                          ? null
                                          : e.target.value,
                                    },
                                  });
                                  if (e.target.value.length === 0)
                                    this.setState({
                                      imei: {
                                        ...this.state.imei,
                                        selected: null,
                                      },
                                    });
                                }}
                              />
                            )}
                            {!this.state.docno.DeviceSN && (
                              <Bs
                                brtxasyncselect
                                allowNew
                                className="w-100"
                                labelKey="DeviceSN"
                                isLoading={this.state.imei.loading}
                                disabled={this.state.imei.loading}
                                minLength={6}
                                selected={this.state.imei.selected}
                                promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                                searchText="Hledám data dle imei..."
                                emptyLabel="Nic jsem nenašel."
                                onChange={(e) => {
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ...e[0],
                                    },
                                    imei: { ...this.state.imei, selected: e },
                                  });
                                }}
                                onSearch={this.searchByImei}
                                options={this.state.imei.data}
                                placeholder="Začni psát"
                                renderMenuItemChildren={(option, props) => (
                                  <Fragment>
                                    <Bs row>
                                      <Bs strong>
                                        Dohledáno podle:{" "}
                                        {this.state.imei.searchBy}
                                      </Bs>
                                    </Bs>
                                    <Bs row>
                                      <Bs col xs={12}>
                                        IMEI: {option.DeviceSN}
                                      </Bs>
                                      <Bs col xs={12}>
                                        Zakázka: {option?.NumAtCard}
                                      </Bs>
                                    </Bs>
                                  </Fragment>
                                )}
                              />
                            )}
                          </Bs>
                          <Bs col xs={6} className="mt-4">
                            <Bs formtext id="basic-addon1">
                              Sériové číslo
                            </Bs>
                            {this.state.docno.ProductCodeSN && (
                              <Bs
                                formcontrol
                                value={this.state.docno.ProductCodeSN}
                                onChange={(e) => {
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ProductCodeSN:
                                        e.target.value.length === 0
                                          ? null
                                          : e.target.value,
                                    },
                                  });
                                  if (e.target.value.length === 0)
                                    this.setState({
                                      productCodeSN: {
                                        ...this.state.productCodeSN,
                                        selected: null,
                                      },
                                    });
                                }}
                              />
                            )}
                            {!this.state.docno.ProductCodeSN && (
                              <Bs
                                brtxasyncselect
                                labelKey="ProductCodeSN"
                                isLoading={this.state.productCodeSN.loading}
                                disabled={this.state.productCodeSN.loading}
                                minLength={2}
                                allowNew
                                className="w-100"
                                selected={this.state.productCodeSN.selected}
                                promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                                searchText="Hledám data dle SN..."
                                emptyLabel="Nic jsem nenašel."
                                onChange={(e) => {
                                  console.log(e);
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ...e[0],
                                    },
                                    productCodeSN: {
                                      ...this.state.productCodeSN,
                                      selected: e,
                                    },
                                  });
                                }}
                                onSearch={this.searchByproductCodeSN}
                                options={this.state.productCodeSN.data}
                                placeholder="Začni psát"
                                renderMenuItemChildren={(option, props) => (
                                  <Fragment>
                                    <Bs row>
                                      <Bs strong>
                                        Dohledáno podle:{" "}
                                        {this.state.imei.searchBy}
                                      </Bs>
                                    </Bs>
                                    <Bs row>
                                      <Bs col xs={12}>
                                        S/N: {option?.ProductCodeSN}
                                      </Bs>
                                      <Bs col xs={12}>
                                        Zakázka: {option?.NumAtCard}
                                      </Bs>
                                    </Bs>
                                  </Fragment>
                                )}
                              />
                            )}
                          </Bs>
                          <Bs col xs={6} className="mt-4">
                            <Bs formtext id="basic-addon1">
                              Zakázka zákazníka
                            </Bs>
                            {this.state.docno.NumAtCard && (
                              <Bs
                                formcontrol
                                value={this.state.docno.NumAtCard}
                                onChange={(e) => {
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      NumAtCard:
                                        e.target.value.length === 0
                                          ? null
                                          : e.target.value,
                                    },
                                  });
                                  if (e.target.value.length === 0)
                                    this.setState({
                                      numAtCard: {
                                        ...this.state.numAtCard,
                                        selected: null,
                                      },
                                    });
                                }}
                              />
                            )}
                            {!this.state.docno.NumAtCard && (
                              <Bs
                                brtxasyncselect
                                className="w-100"
                                labelKey="NumAtCard"
                                isLoading={this.state.numAtCard.loading}
                                disabled={this.state.numAtCard.loading}
                                minLength={2}
                                allowNew
                                selected={this.state.numAtCard.selected}
                                promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                                searchText="Hledám v datech..."
                                emptyLabel="Nic jsem nenašel."
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ...e[0],
                                    },
                                    numAtCard: {
                                      ...this.state.numAtCard,
                                      selected: e,
                                    },
                                  })
                                }
                                onSearch={this.searchByNumAtCard}
                                options={this.state.numAtCard.data}
                                placeholder="Začni psát"
                                renderMenuItemChildren={(option, props) => (
                                  <Fragment>
                                    <Bs row>
                                      <Bs col xs={12}>
                                        Zdroj: {option?.api_name}
                                      </Bs>
                                      <Bs col xs={12}>
                                        Zakázka: {option?.NumAtCard}
                                      </Bs>
                                      <Bs col xs={12}>
                                        Zákazník: {option?.delivery_contact}
                                      </Bs>
                                    </Bs>
                                  </Fragment>
                                )}
                              />
                            )}
                          </Bs>
                          <Bs col xs={6} className="mt-4">
                            <Bs formtext id="basic-addon1">
                              Číslo pojištění
                            </Bs>
                            {this.state.docno.CisPoj && (
                              <Bs
                                formcontrol
                                value={this.state.docno.CisPoj}
                                onChange={(e) => {
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      CisPoj:
                                        e.target.value.length === 0
                                          ? null
                                          : e.target.value,
                                    },
                                  });
                                  if (e.target.value.length === 0)
                                    this.setState({
                                      insuranceNo: {
                                        ...this.state.insuranceNo,
                                        selected: null,
                                      },
                                    });
                                }}
                              />
                            )}
                            {!this.state.docno.CisPoj && (
                              <Bs
                                brtxasyncselect
                                className="w-100"
                                labelKey="CisPoj"
                                isLoading={this.state.insuranceNo.loading}
                                disabled={this.state.insuranceNo.loading}
                                minLength={2}
                                selected={this.state.insuranceNo.selected}
                                allowNew
                                promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                                searchText="Hledám výrobce..."
                                emptyLabel="Nic jsem nenašel."
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ...e[0],
                                    },
                                    insuranceNo: {
                                      ...this.state.insuranceNo,
                                      selected: e,
                                    },
                                  })
                                }
                                onSearch={this.searchByInsuranceNo}
                                options={this.state.insuranceNo.data}
                                placeholder="Začni psát"
                                renderMenuItemChildren={(option, props) => (
                                  <Fragment>
                                    <Bs row>
                                      <Bs col xs={12}>
                                        Zdroj: {option?.api_name}
                                      </Bs>
                                      <Bs col xs={12}>
                                        Zakázka: {option?.NumAtCard}
                                      </Bs>
                                      <Bs col xs={12}>
                                        Zákazník: {option?.delivery_contact}
                                      </Bs>
                                    </Bs>
                                  </Fragment>
                                )}
                              />
                            )}
                          </Bs>
                        </>
                      </Bs>
                    )}
                    {this.state.selectGroup === 1 && (
                      <Bs row>
                        <Bs col xs={12} lg={4}>
                          <Bs row>
                            <Bs formtext>Typ přístroje</Bs>
                          </Bs>
                          {this.state.docno.DeviceType && (
                            <Bs
                              brtxselect
                              options={this.state.device.data.filter(
                                (f) =>
                                  f.DeviceType === this.state.docno.DeviceType
                              )}
                              value={
                                this.state.device.data.filter(
                                  (f) =>
                                    f.DeviceType === this.state.docno.DeviceType
                                )[0]
                              }
                              onChange={(e) => {
                                this.setState({
                                  docno: {
                                    ...this.state.docno,
                                    DeviceType: null,
                                  },
                                  device: {
                                    ...this.state.device,
                                    selected: null,
                                  },
                                });
                              }}
                            />
                          )}
                          {!this.state.docno.DeviceType && (
                            <Bs
                              brtxasyncselect
                              className="w-100"
                              isLoading={this.state.device.loading}
                              disabled={this.state.device.loading}
                              minLength={2}
                              selected={this.state.device.selected}
                              promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                              searchText="Hledám typy přístrojů..."
                              emptyLabel="Nic jsem nenašel."
                              onChange={(e) =>
                                this.setState({
                                  docno: {
                                    ...this.state.docno,
                                    ...e[0],
                                  },
                                  device: {
                                    ...this.state.device,
                                    selected: e,
                                  },
                                })
                              }
                              onSearch={this.searchDevice}
                              options={this.state.device.data}
                              placeholder="Začni psát"
                              renderMenuItemChildren={(option, props) => (
                                <Fragment>
                                  <Bs row>{option.label}</Bs>
                                </Fragment>
                              )}
                            />
                          )}
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Druh opravy</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.reptype.filter(
                                (f) =>
                                  f.value === this.state.docno.DeviceRepairType
                              )[0]
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DeviceRepairType: e.value,
                                },
                              })
                            }
                            options={this.state.reptype}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Distributor</Bs>
                          <Bs
                            id="device_reseller"
                            brtxasyncselect
                            className="w-100"
                            isLoading={this.state.reseller.loading}
                            disabled={this.state.reseller.loading}
                            minLength={2}
                            selected={this.state.reseller.selected}
                            promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                            searchText="Hledám distributory..."
                            emptyLabel="Nic jsem nenašel."
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DeviceReseller: e[0].value,
                                },
                                reseller: {
                                  ...this.state.reseller,
                                  selected: e,
                                },
                              })
                            }
                            onSearch={this.searchReseller}
                            options={this.state.reseller.data}
                            placeholder="Začni psát"
                            renderMenuItemChildren={(option, props) => (
                              <Fragment>
                                <Bs row>{option.label}</Bs>
                              </Fragment>
                            )}
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Priorita zpracování</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.priorZprac.filter(
                                (f) =>
                                  f.value === this.state.docno.PrioritaZprac
                              )[0]
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  PrioritaZprac: e.value,
                                },
                              })
                            }
                            options={this.state.priorZprac}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={8}>
                          <Bs formtext>Příslušenství</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.docno.Prislus !== null
                                ? this.state.prislus.filter(
                                    (f) =>
                                      this.state.docno.Prislus.split("|")
                                        .map((e) => e)
                                        .indexOf(f.value.toString()) > -1
                                  )
                                : []
                            }
                            isMulti
                            onChange={(e) => {
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  Prislus: e.map((e) => e.value).join("|"),
                                },
                              });
                              console.log(
                                "prislus",
                                e
                                  .map((e) => e.value)
                                  .join("|")
                                  .split("|")
                                  .map((x) => x)
                              );
                            }}
                            options={this.state.prislus}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={6}>
                          <Bs formtext>Stav přístroje</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.deviceState.filter(
                                (f) =>
                                  f.value === this.state.docno.StavPristroje
                              )[0]
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  StavPristroje: e.value,
                                },
                              })
                            }
                            options={this.state.deviceState}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={6}>
                          <Bs formtext>Požadavek zákazníka</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.custReq.filter(
                                (f) => f.value === this.state.docno.PozadavZak
                              )[0]
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  PozadavZak: e.value,
                                },
                              })
                            }
                            options={this.state.custReq}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={12}>
                          <Bs formtext>Textový popis stavu zařízení</Bs>
                          <Bs
                            formcontrol
                            as="textarea"
                            rows={3}
                            value={this.state.docno.Poskozeni}
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  Poskozeni: e.target.value,
                                },
                              })
                            }
                            placeholder="Vyplň popis stavu přístroje"
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Závada 1</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.defect.data.filter(
                                (f) =>
                                  f.value === this.state.docno.DeviceDefect1
                              )[0]
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DeviceDefect1: e.value,
                                  DeviceDefect1Ver: e.Version,
                                },
                              })
                            }
                            options={this.state.defect.data}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Závada 2</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.defect.data.filter(
                                (f) =>
                                  f.value === this.state.docno.DeviceDefect2
                              )[0]
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DeviceDefect2: e.value,
                                  DeviceDefect2Ver: e.Version,
                                },
                              })
                            }
                            options={this.state.defect.data}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Závada 3</Bs>
                          <Bs
                            brtxselect
                            value={
                              this.state.defect.data.filter(
                                (f) =>
                                  f.value === this.state.docno.DeviceDefect3
                              )[0]
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DeviceDefect3: e.value,
                                  DeviceDefect3Ver: e.Version,
                                },
                              })
                            }
                            options={this.state.defect.data}
                            placeholder="-- Vyber --"
                          />
                        </Bs>
                        <Bs col xs={12} lg={12}>
                          <Bs formtext>Textový popis závady od zákazníka</Bs>
                          <Bs
                            formcontrol
                            as="textarea"
                            rows={3}
                            value={this.state.docno.DeviceDefectDescEx}
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DeviceDefectDescEx: e.target.value,
                                },
                              })
                            }
                            placeholder="Vyplň popis závady od zákazníka"
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Datum prodeje</Bs>
                          <Bs
                            formcontrol
                            type="date"
                            disabled={
                              this.state.docno.Predprodej === 0 ? false : true
                            }
                            value={this.state.docno.DatProdej?.split("T")[0]}
                            onChange={(e) => {
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DatProdej: e.target.value,
                                },
                              });
                            }}
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Předprodejní reklamace</Bs>
                          <Bs
                            formswitch
                            checked={
                              this.state.docno.Predprodej === 0 ? false : true
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  Predprodej: e.target.checked ? 1 : 0,
                                  DatProdej: null,
                                },
                              })
                            }
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Datum externího příjmu</Bs>
                          <Bs
                            formcontrol
                            type="date"
                            value={this.state.docno.DatExtPr?.split("T")[0]}
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  DatExtPr: e.target.value,
                                },
                              })
                            }
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Baterie</Bs>
                          <Bs
                            formswitch
                            checked={
                              this.state.docno.BattYN === 0 ? false : true
                            }
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  BattYN: e.target.checked ? 1 : 0,
                                },
                              })
                            }
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Baterie SN</Bs>
                          <Bs
                            formcontrol
                            disabled={
                              this.state.docno.BattYN === 0 ? true : false
                            }
                            value={this.state.docno.BattSN}
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  BattSN: e.target.value,
                                },
                              })
                            }
                          />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                          <Bs formtext>Zámek přístroje</Bs>
                          <Bs
                            formcontrol
                            value={this.state.docno.ALL_Zamek}
                            onChange={(e) =>
                              this.setState({
                                docno: {
                                  ...this.state.docno,
                                  ALL_Zamek: e.target.value,
                                },
                              })
                            }
                          />
                        </Bs>
                      </Bs>
                    )}
                    {this.state.selectGroup === 2 && (
                      <Bs row>
                        {/* SAMSUNG */}
                        {this.state.docno.DeviceFirmCode === 2 && (
                          <>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Autorizace</Bs>
                              <Bs
                                formcontrol
                                value={this.state.docno.OTA}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      OTA: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>SAW žádost</Bs>
                              <Bs
                                formswitch
                                disabled={!this.state.docno.SAM_DuvodOTA}
                                checked={
                                  this.state.docno.SAM_SAW === 1 ? true : false
                                }
                                data-tip="Pokud je pole neaktivní vyplň nejdříve pole Důvod OTA"
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      SAM_SAW: e.target.checked ? 1 : 0,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Důvod OTA</Bs>
                              <Bs
                                brtxselect
                                isClearable
                                placeholder="Vyber"
                                options={this.state.ota.data}
                                value={
                                  this.state.docno?.SAM_DuvodOTA
                                    ? this.state.ota.data.filter(
                                        (f) =>
                                          f.value ===
                                          this.state.docno?.SAM_DuvodOTA
                                      )[0]
                                    : null
                                }
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      SAM_DuvodOTA: e?.value,
                                      SAM_SAW: !e?.value
                                        ? null
                                        : this.state.docno.SAM_SAW,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Typ zákazníka</Bs>
                              <Bs
                                brtxselect
                                placeholder="Vyber"
                                value={
                                  this.state.samCustType.data.filter(
                                    (f) =>
                                      f.value === this.state.docno.SAM_CustType
                                  )[0]
                                }
                                options={this.state.samCustType.data}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      SAM_CustType: e.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Datum výroby</Bs>
                              <Bs
                                formcontrol
                                type="date"
                                value={
                                  this.state.docno.SAM_DatVyr?.split("T")[0]
                                }
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      SAM_DatVyr: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Customizace</Bs>
                              <Bs
                                brtxselect
                                placeholder="Vyber"
                                value={
                                  this.state.samCustSw.data.filter(
                                    (f) =>
                                      f.value === this.state.docno.SAM_SWCust
                                  )[0]
                                }
                                options={this.state.samCustSw.data}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      SAM_SWCust: e.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                          </>
                        )}
                        {/* APPLE */}
                        {this.state.docno.DeviceFirmCode === 8 && (
                          <>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>FMI</Bs>
                              <Bs
                                formswitch
                                checked={this.state.docno.APL_FMI}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      APL_FMI: e.target.checked,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Cizí distribuce</Bs>
                              <Bs
                                formswitch
                                checked={this.state.docno.APL_CiziDistribuce}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      APL_CiziDistribuce: e.target.checked,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Dokumenty</Bs>
                              <Bs
                                formswitch
                                checked={this.state.docno.APL_Dokumenty}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      APL_Dokumenty: e.target.checked,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Neshoda</Bs>
                              <Bs
                                formswitch
                                checked={this.state.docno.APL_Neshoda}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      APL_Neshoda: e.target.checked,
                                    },
                                  })
                                }
                              />
                            </Bs>
                          </>
                        )}
                        {/* TCCM */}
                        {this.state.docno.DeviceFirmCode === 49 && (
                          <>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Země určení</Bs>
                              <Bs
                                brtxselect
                                isClearable
                                options={this.state.tccmUrceni.data}
                                placeholder="Vyber"
                                value={
                                  this.state.tccmUrceni.data.filter(
                                    (f) =>
                                      f.value === this.state.docno.TCCM_Urceni
                                  )[0]
                                }
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      TCCM_Urceni: e.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                          </>
                        )}
                        {/* ALCATEL */}
                        {this.state.docno.DeviceFirmCode === 15 && (
                          <>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>HWV In</Bs>
                              <Bs
                                formcontrol
                                value={this.state.docno.ICS_HWV_In}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ICS_HWV_In: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Datum výroby FR</Bs>
                              <Bs
                                formcontrol
                                value={this.state.docno.ALC_ProductionDate}
                                onChange={(e) => {
                                  if (e.target.value.length < 3) {
                                    this.setState({
                                      docno: {
                                        ...this.state.docno,
                                        ALC_ProductionDate: e.target.value,
                                      },
                                    });
                                  }

                                  if (e.target.value.length === 3)
                                    this.alcatel_production_translate(
                                      e.target.value
                                    );
                                }}
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Datum výroby CZ</Bs>
                              <Bs
                                formcontrol
                                disabled
                                value={this.state.docno.ALC_ProductionDate_NUM}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ALC_ProductionDate_NUM: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Původní IMEI</Bs>
                              <Bs
                                formcontrol
                                value={this.state.docno.ALC_PuvodniIMEI}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ALC_PuvodniIMEI: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Datum ukončení záruky</Bs>
                              <Bs
                                formcontrol
                                type="date"
                                value={this.state.docno.ALC_DatUkZar}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      ALC_DatUkZar: e.target.value.split(
                                        "T"
                                      )[0],
                                    },
                                  })
                                }
                              />
                            </Bs>
                          </>
                        )}
                        {/* NOKIA */}
                        {this.state.docno.DeviceFirmCode === 1 && (
                          <>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Typ zákazníka</Bs>
                              <Bs
                                brtxselect
                                placeholder="Vyber"
                                options={this.state.nokCustType.data}
                                value={
                                  this.state.nokCustType.data.filter(
                                    (f) =>
                                      f.value === this.state.docno.NOK_CustType
                                  )[0]
                                }
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      NOK_CustType: e.value,
                                    },
                                  })
                                }
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Sales code</Bs>
                              <Bs
                                formcontrol
                                value={this.state.docno.NOK_SalesCode}
                                onChange={(e) => {
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      NOK_SalesCode: e.target.value,
                                    },
                                  });
                                }}
                              />
                            </Bs>
                            <Bs col xs={12} lg={4}>
                              <Bs formtext>Datum ukončení záruky</Bs>
                              <Bs
                                formcontrol
                                type="date"
                                value={this.state.docno.DatUkZar}
                                onChange={(e) =>
                                  this.setState({
                                    docno: {
                                      ...this.state.docno,
                                      DatUkZar: e.target.value.split("T")[0],
                                    },
                                  })
                                }
                              />
                            </Bs>
                          </>
                        )}
                      </Bs>
                    )}
                    {this.state.selectGroup === 3 && (
                      <Bs row>
                        {this.state.disagreement.map((e, idx) => (
                          <Bs card bg={VARIANT.WHITE} className="mb-2">
                            <Bs cardheader>
                              <Bs row>
                                <Bs
                                  col
                                  xs={12}
                                  className="d-flex justify-content-between"
                                >
                                  <Bs span>{e.type}</Bs>
                                  <Bs
                                    formswitch
                                    onChange={(f) => {
                                      let ActualDis = this.state.disagreement;
                                      ActualDis[idx] = {
                                        ...e,
                                        selected: f.target.checked,
                                      };
                                      this.setState({
                                        disagreement: ActualDis,
                                      });
                                    }}
                                    checked={e.selected}
                                  />
                                </Bs>
                              </Bs>
                            </Bs>
                            {e.selected && (
                              <Bs cardbody>
                                <Bs
                                  formcontrol
                                  as="textarea"
                                  rows={6}
                                  value={e.text}
                                />
                              </Bs>
                            )}
                          </Bs>
                        ))}
                      </Bs>
                    )}
                  </>
                )}
              </>
            )}
          </Bs>
          <Bs modalfooter>
            <Bs row>
              <Bs
                col
                className={
                  this.state.docno.DocNo > 0
                    ? "d-flex justify-content-between"
                    : "d-flex justify-content-end"
                }
              >
                {this.state.docno.DocNo > 0 && (
                  <>
                    <Bs
                      button
                      variant={VARIANT.DANGER}
                      size={SIZE.SM}
                      className="me-2"
                      onClick={() => this.Update(true)}
                      disabled={this.state.loading}
                    >
                      {this.state.loading ? (
                        <Bs brtxspin />
                      ) : (
                        "Stornovat zakázku"
                      )}
                    </Bs>
                    <Bs
                      button
                      variant={VARIANT.SUCCESS}
                      size={SIZE.SM}
                      className="me-2"
                      onClick={() => this.Update(false)}
                      disabled={this.state.loading}
                    >
                      {this.state.loading ? <Bs brtxspin /> : "Upravit zakázku"}
                    </Bs>
                  </>
                )}
                {this.state.docno.DocNo < 1 && !prepare && (
                  <>
                    <Bs
                      button
                      variant={VARIANT.SUCCESS}
                      size={SIZE.SM}
                      onClick={() => this.create(0)}
                      disabled={this.state.loading}
                    >
                      {this.state.loading ? <Bs brtxspin /> : "Příjem"}
                    </Bs>
                  </>
                )}
                {prepare && (
                  <>
                    <Bs
                      button
                      variant={VARIANT.SUCCESS}
                      size={SIZE.SM}
                      onClick={() =>
                        this.setState({
                          brtxcard: { ...this.state.brtxcard, open: true },
                        })
                      }
                      disabled={this.state.loading}
                    >
                      {this.state.loading ? <Bs brtxspin /> : "Předpříjem"}
                    </Bs>
                  </>
                )}
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}

export default NewDocument;
